<template>
  <div data-test-id="ResendWelcomeEmailComponent" class="resend-email">
    <b-button variant="outline-danger" data-test-id="ResendWelcomeEmailButton" @click="showModal">
      Resend Welcome Email
    </b-button>
    <b-modal id="resend-form" ref="resendForm" centered title="Resend Welcome Email" @hide="hideModal">
      <h3>This will resend the welcome email to the selected user.</h3>
      <template #modal-footer>
        <b-button variant="outline-secondary" data-test-id="CancelResendButton" @click="hideModal">
          Cancel
        </b-button>
        <b-button variant="outline-success" data-test-id="ResendButton" @click="save($event)">
          Resend
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ResendWelcomeEmail",
  components: {},
  data(): any {
    return {};
  },
  methods: {
    showModal(): any {
      this.$refs.resendForm.show();
    },
    hideModal(): any {
      this.$refs.resendForm.hide();
    },
    save(event): any {
      event.preventDefault();
      this.$emit("resend-welcome-email");
      this.hideModal();
    }
  }
});
</script>

<style scoped>
.resend-email {
  width: 50%;
}
</style>
